import { computed } from "@ember/object"
import Service from "@ember/service"
import algoliasearch from "algoliasearch"

export default class Algolia extends Service {
  get index() {
    var client = algoliasearch("O7L4OQENOZ", "10cdfef85b6690cfe4a7bb1f030d8fd9")
    return client.initIndex("common-standards-project")
  }

  get help() {
    var client = algoliasearch("O7L4OQENOZ", "593c807db82cd9b033bca564730bb871")
    return client.initIndex("common-curriculum-kb")
  }

  get canonicalGroups() {
    var client = algoliasearch("O7L4OQENOZ", "593c807db82cd9b033bca564730bb871")
    return client.initIndex("canonical-groups")
  }
}
